import { render } from "./VideoDropdownModal.vue?vue&type=template&id=678f37d2&scoped=true"
import script from "./VideoDropdownModal.vue?vue&type=script&lang=js"
export * from "./VideoDropdownModal.vue?vue&type=script&lang=js"

import "./VideoDropdownModal.vue?vue&type=style&index=0&id=678f37d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678f37d2"]])

export default __exports__